import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig } from '@intelliarts/ia-react-template';

import authConfig, { IA_PEOPLE_MENU_GROUP } from '../../../config/authConfig';
import { EmployeesStore } from '../store/employeesStore';
import { EMPLOYEES_LOCALE_PATH } from '../locales';

export const EmployeesRoutes = {
  default: 'employees',
};

export const EmployeesPageConfig: ReactPageConfig = {
  name: `${EMPLOYEES_LOCALE_PATH}.pageConfig.name`,
  path: EmployeesRoutes.default,
  allowedRoles: [ authConfig.roles.ADMIN ],
  component: lazy(() => import('../components/EmployeesPage')),
  storeDependencies: [
    { store: EmployeesStore },
  ],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/PeopleAlt')),
    label: `${EMPLOYEES_LOCALE_PATH}.pageConfig.label`,
    group: IA_PEOPLE_MENU_GROUP,
    isCollapsibleGroup: true,
  })
};
